import { gql } from '@apollo/client';

export const CREATE_NE_ASGPPP = gql`
  mutation createNeASGPPP($neAsgppp: NeAsgpppInput!) {
    createNeAsgppp(neAsgppp: $neAsgppp) {
      id
    }
  }
`;
